import APIRequest from '../api/APIRequest';

export const studentService = {
  // Get all students
  getAllStudents: async (token) => {
    try {
      console.log('Fetching students with token:', token ? 'present' : 'missing');
      const api = new APIRequest();
      const response = await api.request('/admin/getAllStudents', 'GET', {}, token);
      console.log('API response:', response);
      if (response.success) {
        console.log('Students returned:', response.students?.length || 0);
        return response.students;
      } else {
        console.log('API returned success: false');
        return [];
      }
    } catch (error) {
      console.error('Error fetching students:', error);
      return [];
    }
  },

  // Get student by ID
  getStudentById: async (id, token) => {
    try {
      const api = new APIRequest();
      const response = await api.request(`/admin/getStudent?id=${id}`, 'GET', {}, token);
      if (response.success) {
        return response.student;
      } else {
        return null;
      }
    } catch (error) {
      console.error('Error fetching student:', error);
      return null;
    }
  },

  // Create new student
  createStudent: async (studentData, token) => {
    try {
      const api = new APIRequest();
      const response = await api.request('/admin/createStudent', 'POST', studentData, token);
      return response;
    } catch (error) {
      console.error('Error creating student:', error);
      return { success: false, message: 'Failed to create student' };
    }
  },

  // Update student
  updateStudent: async (id, studentData, token) => {
    try {
      const api = new APIRequest();
      const response = await api.request(`/admin/updateStudent?id=${id}`, 'POST', studentData, token);
      return response;
    } catch (error) {
      console.error('Error updating student:', error);
      return { success: false, message: 'Failed to update student' };
    }
  },

  // Delete student
  deleteStudent: async (id, token) => {
    try {
      const api = new APIRequest();
      const response = await api.request(`/admin/deleteStudent?id=${id}`, 'DELETE', {}, token);
      return response;
    } catch (error) {
      console.error('Error deleting student:', error);
      return { success: false, message: 'Failed to delete student' };
    }
  },
};
